<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormAgricultureData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM AGRICULTURE</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <div *ngFor="let item of incomeFormAgricultureData; let idx = index" style="page-break-inside: avoid;" class="row mb-5">
    <div class="col-12 mb-4 return-view-section-title">
      {{ getAgricultureTypeTitle(item) }}
    </div>
    <div class="col-12 mb-3">
      <div class="return-view-text-fields">
        <ng-container *ngFor="let field of getTextParticulars(item)">
          <div class="return-view-text-field" *ngIf="shouldShowTextField(item, field)">
            <span class="return-view-text-label">{{ field.title }}:</span>
            <span class="return-view-text-value">{{ getTextFieldDisplayValue(item, field) }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="col-12" *ngIf="!isFailureOfDeduction(item) && getAmountParticulars(item).length > 0">
      <table class="table table-bordered income-agriculture-table">
        <thead>
          <tr class="text-center">
            <th style="width: 70%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let particular of getAmountParticulars(item)">
            <td>{{ particular.title }}</td>
            <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-12 mt-4" *ngIf="getBalanceSheetParticulars(item) as balanceRows">
      <ng-container *ngIf="balanceRows.length > 0">
        <div class="text-center mb-2"> <strong>Balance Sheet Summary</strong></div>
        <table class="table table-bordered income-agriculture-table">
          <thead>
            <tr class="text-center">
              <th style="width: 70%">Particulars</th>
              <th style="width: 30%">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let particular of balanceRows">
              <td>{{ particular.title }}</td>
              <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <div class="col-12" *ngIf="isFailureOfDeduction(item) && getFailureOfDeductionList(item).length > 0">
      <table class="table table-bordered income-agriculture-table">
        <thead>
          <tr class="text-center">
            <th style="width: 5%">SL</th>
            <th *ngFor="let column of failureOfDeductionColumns" [style.width.%]="column.isAmount ? 19 : 24">
              {{ column.title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getFailureOfDeductionList(item); let rowIdx = index">
            <td class="text-center">{{ rowIdx + 1 }}</td>
            <td *ngFor="let column of failureOfDeductionColumns" [class.text-right]="column.isAmount" [class.pr-3]="column.isAmount">
              <ng-container *ngIf="column.isAmount; else textValue">
                {{ getFailureOfDeductionRowValue(row, column.key) | currencySeparatorBD }}
              </ng-container>
              <ng-template #textValue>{{ getFailureOfDeductionRowValue(row, column.key) }}</ng-template>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="font-weight-bold">
            <td colspan="2">Total</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'amount') | currencySeparatorBD }}</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'tdsAmount') | currencySeparatorBD }}</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'tds50Parent') | currencySeparatorBD }}</td>
            <td class="text-right pr-3">{{ getFailureOfDeductionTotal(item, 'totalPayable') | currencySeparatorBD }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>
